<script setup>
// Components
import Button from '@/Components/Button/Button.vue';

const props = defineProps({
    item: Object,
    index: Number,
});
</script>

<template>
    <div
        class="relative px-12 py-12 rounded-lg md:pt-16 shadow-md pb-[180px]"
        :class="{ 'bg-primary text-bodyColor': index == 1 }"
        v-if="item"
    >
        <div>
            <h2 class="font-bold uppercase text-center text-xl md:text-[27px] md:min-h-[40px]">
                {{ item.package_name }}
            </h2>

            <p v-if="item.package_frequency" class="mb-6 text-center uppercase text-primary">
                {{ item.package_frequency }}
            </p>
        </div>

        <div
            v-if="item.text"
            v-html="item.text"
            class="prose text-bodyColor"
            :class="{ 'marker:text-primary': index != 1, 'marker:text-black': index == 1 }"
        ></div>

        <div class="absolute left-0 w-full px-8 bottom-12">
            <div class="flex items-center justify-center gap-4 mt-10 md:gap-1 md:flex-col">
                <span v-if="item.price" class="text-3xl md:text-[50px] uppercase mb-2"> €{{ item.price }} </span>
                <span v-if="item.price_frequency" class="uppercase">{{ item.price_frequency }}</span>
            </div>
        </div>
    </div>
</template>
